const awsConfig = {
  Auth: {
    Cognito: {
      region: process.env.REACT_APP_REGION,
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
      loginWith: {
        email: true,
      },
      userAttributes: {
        email: { required: true },
        name: { required: true },
      },
      signUpVerificationMethod: "code",
    },
  },
};

export default awsConfig;